import handleMultipleArgs from './_handleMultipleArgs';
import setRequestHeaders from './_setRequestHeaders';
import prepareRequest from './_prepareRequest';
import processHeaders from './_processHeaders';
import mergeConfig from './_mergeConfig';
import onError from './_onError';

/**
 * @public
 * Makes an AJAX request via `XMLHttpRequest` and wrap it in a `Promise`
 *
 * @see https://github.github.io/fetch/
 * @param {Object} args: options to configure the request.
 *        It has the properties: {url, method, headers, data, credentials}
 * @return {Promise}
 */
export default function fetch(...args) {
  const config = mergeConfig(handleMultipleArgs(args));
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    prepareRequest(config);
    xhr.onload = () => {
      resolve({
        status: xhr.status,
        statusText: xhr.statusText,
        headers: processHeaders.parse(xhr.getAllResponseHeaders()),
        response: 'response' in xhr ? xhr.response : xhr.responseText,
        url: config.url,
      });
    };
    xhr.onerror = onError(config, reject);
    xhr.ontimeout = xhr.onerror;
    xhr.open(config.method, config.url, true);
    // withCredentials for cross-domain requests
    if (config.credentials === 'include') {
      xhr.withCredentials = true;
    }
    if (config.data === undefined) config.data = null;
    setRequestHeaders(xhr, config.headers);
    xhr.send(config.data);
  });
}
